import { render } from "./ServicesAdmin.vue?vue&type=template&id=7711e720"
import script from "./ServicesAdmin.vue?vue&type=script&lang=js"
export * from "./ServicesAdmin.vue?vue&type=script&lang=js"

import "./ServicesAdmin.vue?vue&type=style&index=0&id=7711e720&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__